import { Component, Inject, Optional, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, FormControl, ValidationErrors, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { AppSettings } from '../../../app.settings';
import { BrandDomainTarget } from '../../../services/brand-domain/brand-domain.service';

interface AddBrandDomainDialogData {
  target?: BrandDomainTarget;
  showTargetContext?: boolean;
}

interface AddBrandDomainDialogResult {
  subDomain: string;
  target?: BrandDomainTarget;
}

@Component({
    selector: 'app-add-brand-domain-dialog',
    templateUrl: './add-brand-domain-dialog.component.html',
    styleUrls: ['./add-brand-domain-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddBrandDomainDialogComponent {
  newDomain = new FormControl('', [Validators.required, this.noDotsValidator]);
  env = AppSettings.getEnv();

  constructor(
    private dialogRef: MatDialogRef<AddBrandDomainDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data?: AddBrandDomainDialogData,
  ) {}

  get suffix(): string {
    if (this.target === 'qa') {
      return '.qa.wallit.app';
    }
    if (this.target === 'demo') {
      return '.demo.wallit.app';
    }
    return this.env === 'prod' ? '.wallit.app' : `.${this.env}.wallit.app`;
  }

  get preview(): string {
    const value = this.newDomain.value || 'domain-example';
    return `${value}${this.suffix}`;
  }

  get target(): BrandDomainTarget | undefined {
    return this.data?.target;
  }

  get showTargetContext(): boolean {
    return !!this.data?.showTargetContext && !!this.target;
  }

  get targetLabel(): string {
    return this.target === 'demo' ? 'Demo' : 'QA';
  }

  noDotsValidator(control: AbstractControl): ValidationErrors | null {
    const value = `${control.value || ''}`;
    return value.includes('.') ? { invalid: true } : null;
  }

  cancel(): void {
    this.dialogRef.close();
  }

  save(): void {
    if (this.newDomain.invalid) {
      return;
    }

    const subDomain = `${this.newDomain.value || ''}`.trim();
    if (!subDomain) {
      return;
    }

    const result: AddBrandDomainDialogResult = { subDomain };
    if (this.target) {
      result.target = this.target;
    }
    this.dialogRef.close(result);
  }
}
